.border-radius-large {
  border-radius: var(--rc-theme-border-radius-lg);
}

.border-radius-large ~ :global(.ant-image-mask) {
  border-radius: var(--rc-theme-border-radius-lg);
}

.border-radius-small {
  border-radius: var(--rc-theme-border-radius-base);
}

.border-radius-small ~ :global(.ant-image-mask) {
  border-radius: var(--rc-theme-border-radius-base);
}

.object-fit-cover {
  object-fit: cover;
}

.small {
  &:global(.ant-image-img) {
    width: 16px;
  }
}

.middle {
  &:global(.ant-image-img) {
    width: 24px;
  }
}

.large {
  &:global(.ant-image-img) {
    width: 32px;
  }
}

.extra-large {
  &:global(.ant-image-img) {
    width: 40px;
  }
}

.rounded {
  border-radius: 50%;
}

.wrapper--fluid {
  width: 100%;
  height: auto;
}
